import dayjs from 'dayjs';
import Image from 'next/image';

import { TextLink } from '@/components/text-link';
import { joinSgcmSite } from '@/utils/url/join/public';

import {
  PROMOTION_MODEL_COVER_IMAGE_HEIGHT,
  PROMOTION_MODEL_COVER_IMAGE_LOGO_HEIGHT,
  PROMOTION_MODEL_COVER_IMAGE_WIDTH,
  PROMOTION_POSTED_ON_DATE_FORMAT,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const NormalPromo: Component = ({ item }) => (
  <div
    className={styles.containerRoot}>
    <div
      className={styles.containerPromotionContent}>
      <div className={styles.containerPromotionTitleContent}>
        <a href={item?.dealer.url}>
          <Image
            alt="Promotion image of vehicle"
            className={styles.imageVehicleCover}
            height={item?.image?.includes('/logos/')
              ? PROMOTION_MODEL_COVER_IMAGE_LOGO_HEIGHT
              : PROMOTION_MODEL_COVER_IMAGE_HEIGHT}
            src={item?.image ? item.image : ''}
            width={PROMOTION_MODEL_COVER_IMAGE_WIDTH} />
        </a>
        <div className={styles.containerTitleContentDetail}>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: item ? item?.description : '',
            }}
            className={styles.containerPromotionDescription} />
          <div className={styles.containerApplicable}>
            <h2 className={styles.textApplicable}>Applicable Models</h2>
            { item?.isAllModels
              ? (
                <ul
                  className={styles.listPromotionModelLink}>
                  <li
                    key="all models"
                    className={styles.linkPromotionModel}>
                    <TextLink
                      href={`${joinSgcmSite(`/new_cars/newcars_listing.php?DID=${item.dealer.id}`)}`}
                      target="_self"
                      text={`All ${item.make} Models`} />
                  </li>
                </ul>
              )
              : (
                <ul
                  className={styles.listPromotionModelLink}>
                  {
                    item?.models.map(({ title, link: modelLink }) => (
                      <li
                        key={modelLink}
                        className={styles.linkPromotionModel}>
                        <TextLink
                          href={modelLink}
                          text={title} />
                      </li>
                    ))
                  }
                </ul>
              ) }
          </div>
          <div
            className={styles.containerPromotionDate}>
            <span className={styles.textRed}>
              {item?.endsOn}
            </span>
            <span className={styles.textGray}>
              Posted on:
              {' '}
              <time>
                {dayjs(item?.postedOn)
                  .format(PROMOTION_POSTED_ON_DATE_FORMAT)}
              </time>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
);
